/*
  Footer-Sitemap (snippets/footer-category-sitemap.liquid, Teil A 25.09.2026).
  1. Telefon: Spalten auf- und zuklappen. Die Links stehen immer im HTML,
     eingeklappt wird nur per CSS.
  2. PostHog: footer_kollektion_klick { spalte, handle } ueber window.soMessen
     (assets/so-messung.js, sendet nur mit Einwilligung).
*/
(function () {
  if (window.__footerSitemap) return;
  window.__footerSitemap = true;

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var knopf = t.closest('.footer-sitemap__titel');
    if (knopf) {
      var spalte = knopf.closest('.footer-sitemap__spalte');
      var offen = spalte.classList.toggle('ist-offen');
      knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
      return;
    }

    var link = t.closest('.footer-sitemap a');
    if (link && typeof window.soMessen === 'function') {
      var sp = link.closest('.footer-sitemap__spalte');
      var m = (link.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/);
      window.soMessen('footer_kollektion_klick', {
        spalte: sp ? sp.getAttribute('data-spalte') : '',
        handle: m ? decodeURIComponent(m[1]) : ''
      }, true);
    }
  });
})();
